import { render, staticRenderFns } from "./ModalNewPage.vue?vue&type=template&id=c73a256c&scoped=true"
import script from "./ModalNewPage.vue?vue&type=script&lang=js"
export * from "./ModalNewPage.vue?vue&type=script&lang=js"
import style0 from "./ModalNewPage.vue?vue&type=style&index=0&id=c73a256c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73a256c",
  null
  
)

export default component.exports